import actions from "./actions";

const initialState = {
    owner: {}
};

export default function clientReducer(state = initialState, action: { type: string; payload: any; }): any {
    switch (action.type) {
        case actions.SET_CLIENT_OWNER:
            return {...state, owner: action.payload};
        case actions.SET_INIT_CLIENT_OWNER:
            return {...state, owner: {}};
        case actions.SET_INITIAL_OWNER:
            return initialState;
        default:
            return state
    }
}
